/**
 * تک‌منبع برای ذخیره و خواندن توکن و داده‌های احراز هویت.
 * برای بازگشت به کوکی: USE_COOKIE را true کن (وابستگی vue-cookies را نگه دار).
 */
import cookie from "vue-cookies";

const USE_COOKIE = false; // true = cookie (vue-cookies) | false = localStorage

const TOKEN_KEY = "reval_token";
const REVAL_ID_KEY = "reval_id";
const RAVAN_STATUS_KEY = "ravan_reval_status";

const COOKIE_EXPIRY = 60 * 60 * 24 * 90; // 90 روز (ثانیه)
const COOKIE_DOMAIN =
  typeof process !== "undefined" && process.env && process.env.VUE_APP_front_domain
    ? process.env.VUE_APP_front_domain
    : null;

function get(key) {
  if (USE_COOKIE) return cookie.get(key);
  return localStorage.getItem(key);
}

function set(key, value) {
  if (USE_COOKIE) {
    cookie.set(key, value, COOKIE_EXPIRY, null, COOKIE_DOMAIN);
  } else {
    localStorage.setItem(key, value);
  }
}

function remove(key) {
  if (USE_COOKIE) {
    cookie.set(key, "", -1, null, COOKIE_DOMAIN);
  } else {
    localStorage.removeItem(key);
  }
}

export function getToken() {
  return get(TOKEN_KEY);
}

export function setToken(token) {
  set(TOKEN_KEY, token);
}

export function removeToken() {
  remove(TOKEN_KEY);
}

export function getRevalId() {
  return get(REVAL_ID_KEY);
}

export function setRevalId(id) {
  set(REVAL_ID_KEY, String(id));
}

export function getRavanStatus() {
  return get(RAVAN_STATUS_KEY);
}

export function setRavanStatus(status) {
  set(RAVAN_STATUS_KEY, status);
}

export function clearAuth() {
  remove(TOKEN_KEY);
  remove(REVAL_ID_KEY);
  remove(RAVAN_STATUS_KEY);
}

export default {
  getToken,
  setToken,
  removeToken,
  getRevalId,
  setRevalId,
  getRavanStatus,
  setRavanStatus,
  clearAuth,
};
